const projectAgent = {
  path: 'project-agent/:project_type', //办公室
  component: () => import("@/views/member/project-agent/project-agent"),
  meta: {
    tabBar: 'home'
  },
  children:[
    {
      //项目赠品管理
      path: 'gift-manage',
      component: () => import("@/views/member/project-agent/gift-manage"),
    },
    {
      //项目赠品明细
      path: 'gift-detail',
      component: () => import("@/views/member/project-agent/gift-detail"),
    },
    {
      //团队管理
      path: 'team-manage',
      component: () => import("@/views/member/project-agent/team-manage"),
    },
    {
      //数据统计
      path: 'data-info',
      component: () => import("@/views/member/project-agent/data-info"),
      children: [
        {
        //...数据统计明细
        path: 'data-detail',
        component: () => import("@/views/member/project-agent/data-detail"),
        }, {
          //店长推荐销售数据列表
          path: 'data-list',
          component: () => import("@/views/member/project-agent/data-list"),
        },{
          //店长推荐销售数据
          path: 'sell-data',
          component: () => import("@/views/member/project-agent/sell-data"),
        },{
          //销售统计解读
          path: 'sell-explain',
          component: () => import("@/views/member/project-agent/sell-explain"),
        },
      ]
    },
    {
      //资质管理
      path:'management',
      component: () => import("@/views/member/project-agent/management"),
    }
  ]
};

export default projectAgent;